<template>
  <div class="div" v-loading="loading">
    <!-- 表格数据 -->
    <div class="wh100" v-show="ListType == 1">
      <div class="div-top">
        <!-- <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
          >新建工单</el-button
        >
        <el-button
          icon="el-icon-minus"
          type="danger"
          @click="handleDetele(selectedRows)"
          :disabled="selectedRows.length === 0"
          >删除</el-button
        > -->
        <el-button
          icon="el-icon-circle-check"
          type="primary"
          @click="handleAuditList(selectedRows)"
          :disabled="selectedRows.length === 0"
          >批量提交</el-button
        >
        <el-button
          icon="el-icon-s-unfold"
          type="primary"
          @click=";(IsSend = true), (OperatorIds = [])"
          :disabled="selectedRows.length === 0"
          >批量派单</el-button
        >
        <el-button
          icon="el-icon-s-unfold"
          type="primary"
          @click="handleExamineList(selectedRows)"
          :disabled="selectedRows.length === 0"
          >批量审查</el-button
        >
        <el-radio-group
          v-model="ListType"
          style="float: right"
          @change="TypeChange"
        >
          <el-radio-button :label="1">
            <i class="el-icon-menu"></i> 表格</el-radio-button
          >
          <el-radio-button :label="2">
            <i class="el-icon-s-order"></i> 日历表
          </el-radio-button>
        </el-radio-group>
      </div>

      <div class="div-top" style="margin-top: 10px">
        <el-input
          v-model="searchData.Code"
          clearable
          placeholder="请输入工单编号"
          style="width: 230px"
        ></el-input>
        <el-date-picker
          style="width: 230px; margin-left: 10px"
          v-model="searchData.WorkOrderDate"
          value-format="yyyy-MM-dd"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleDateChange"
        >
        </el-date-picker>
        <el-input
          v-model="searchData.DeviceItemName"
          clearable
          placeholder="请输入设备名称/编号"
          style="width: 230px; margin-left: 10px"
        ></el-input>

        <SelectData
          v-model="searchData.OperatorIds"
          multiple
          url="/Base_Manage/Base_User/GetDataList"
          :option="{
            label: 'RealName',
            Id: 'Id',
          }"
          placeholder="请选择人员"
          style="width: 230px; margin-left: 10px"
        ></SelectData>
        <SelectData
          v-model="searchData.State"
          :locationOptions="[
            { label: '待提交', Id: '0' },
            { label: '已提交', Id: '1' },

            { label: '已完成', Id: '3' },
            { label: '已审查', Id: '4' },
          ]"
          placeholder="请选择工单状态"
          style="width: 230px; margin-left: 10px"
        ></SelectData>
        <!-- <el-radio-group v-model="searchData.State" style="margin-left: 10px">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="0">待提交</el-radio-button>
          <el-radio-button label="1">已提交</el-radio-button>
          <el-radio-button label="3">已完成</el-radio-button>
          <el-radio-button label="4">已审查</el-radio-button>
        </el-radio-group> -->
        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <div class="div-center">
        <el-table
          :data="tableData"
          ref="table"
          style="width: 100%"
          height="calc(100% - 40px)"
          @selection-change="handleSelect"
        >
          <el-table-column label="" width="45" type="selection">
          </el-table-column>
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>
          <el-table-column label="工单编号" align="center" prop="Code" sortable>
          </el-table-column>
          <el-table-column
            label="故障编号"
            align="center"
            prop="FaultCode"
            sortable
            v-if="workOrderType == 3 || workOrderType == 2"
          >
            <template slot-scope="scope">
              <span class="link" @click="handleFault(scope.row)">{{
                scope.row.FaultCode
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="设备编号"
            align="center"
            prop="DeviceItemCode"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="设备名称"
            align="center"
            prop="DeviceItemName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="供应商"
            align="center"
            prop="SupplierName"
            sortable
            v-if="workOrderType == 3"
          >
          </el-table-column>
          <el-table-column
            label="安装位置"
            align="center"
            prop="InstallationAreaName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="工单类型"
            align="center"
            prop="WorkOrderTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column label="类型" align="center" prop="TypeName" sortable>
          </el-table-column>
          <el-table-column
            label="工单日期"
            align="center"
            prop="WorkOrderDate"
            sortable
          >
            <template slot-scope="scope">
              {{
                scope.row.WorkOrderDate
                  ? moment(scope.row.WorkOrderDate).format('YYYY-MM-DD')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="创建日期"
            align="center"
            prop="CreateTime"
            sortable
          >
            <template slot-scope="scope">
              {{
                scope.row.CreateTime
                  ? moment(scope.row.CreateTime).format('YYYY-MM-DD')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="人员" align="center" prop="RealName" sortable>
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
            prop="State"
            sortable
            width="75"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.State === 0">待提交</el-tag>
              <el-tag type="success" v-if="scope.row.State === 1"
                >已提交</el-tag
              >
              <el-tag type="warning" v-if="scope.row.State === 2"
                >进行中</el-tag
              >
              <el-tag type="success" v-if="scope.row.State === 3"
                >已完成</el-tag
              >
              <el-tag type="success" v-if="scope.row.State === 4"
                >已审查</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            label="领料状态"
            align="center"
            prop="PickingState"
            sortable
            width="100"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.PickingState === 0">未领料</el-tag>
              <el-tag type="success" v-if="scope.row.PickingState === 1"
                >已领料</el-tag
              >
              <el-tag type="info" v-if="scope.row.PickingState === 2"
                >部分领料</el-tag
              >
              <el-tag type="warning" v-if="scope.row.PickingState === 3"
                >无备件</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            label="评价状态"
            align="center"
            prop="EvaluationStatus"
            sortable
            width="100"
          >
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleEdit(scope.row)"
                v-if="scope.row.State === 0"
                >编辑</el-button
              >
              <el-button
                type="text"
                v-if="
                  scope.row.State >= 1 &&
                  (scope.row.PickingState === 0 || scope.row.PickingState === 2)
                "
                @click="handleApply(scope.row)"
                >领料</el-button
              >
              <el-button
                type="text"
                @click="handleView(scope.row)"
                v-if="scope.row.State !== 0"
                >详情</el-button
              >
              <el-button
                type="text"
                @click="handleAudit(scope.row)"
                v-if="scope.row.State === 0"
                >提交</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.State === 0"
                @click="handleDetele([scope.row])"
                style="color: #f78989"
                >删除</el-button
              >
              <el-button
                type="text"
                @click="handleLog(scope.row)"
                v-if="scope.row.State === 3"
                >审查</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 日历表 -->
    <div class="wh100 rr" v-show="ListType == 2">
      <div class="div-top">
        <!-- <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
          >新建工单</el-button
        > -->

        <el-radio-group
          v-model="ListType"
          style="float: right"
          @change="TypeChange"
        >
          <el-radio-button :label="1">
            <i class="el-icon-menu"></i> 表格</el-radio-button
          >
          <el-radio-button :label="2">
            <i class="el-icon-s-order"></i> 日历表
          </el-radio-button>
        </el-radio-group>
      </div>

      <div class="div-top" style="margin-top: 10px">
        <el-input
          v-model="searchData.DeviceItemName"
          clearable
          placeholder="请输入设备名称/编号"
          style="width: 230px; margin-left: 10px"
        ></el-input>

        <SelectData
          v-model="searchData.OperatorIds"
          multiple
          url="/Base_Manage/Base_User/GetDataList"
          :option="{
            label: 'RealName',
            Id: 'Id',
          }"
          style="width: 230px; margin-left: 10px"
        ></SelectData>
        <el-radio-group v-model="searchData.State" style="margin-left: 10px">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="0">待提交</el-radio-button>
          <el-radio-button label="1">已提交</el-radio-button>
          <!-- <el-radio-button label="2">进行中</el-radio-button> -->
          <el-radio-button label="3">已完成</el-radio-button>
          <el-radio-button label="4">已审查</el-radio-button>
        </el-radio-group>
        <el-button
          type="primary"
          @click="getCalendarDataList"
          style="margin-left: 10px"
          >查询</el-button
        >
        <div class="week-calendar-toolbar" style="float: right">
          <el-button-group>
            <el-button
              :type="weekType === 'prev' ? 'primary' : 'default'"
              size="mini"
              @click="setWeekDates('prev')"
              >上周</el-button
            >
            <el-button
              :type="weekType === 'current' ? 'primary' : 'default'"
              size="mini"
              @click="setWeekDates('current')"
              >本周</el-button
            >
            <el-button
              :type="weekType === 'next' ? 'primary' : 'default'"
              size="mini"
              @click="setWeekDates('next')"
              >下周</el-button
            >
          </el-button-group>
        </div>
      </div>
      <div class="div-center">
        <div class="week-calendar">
          <div
            class="week-day"
            v-for="(item, idx) in weekDates"
            :key="item.name"
          >
            <div class="week-day-header">
              {{ getWeekDayName(idx) }}
              <div class="week-day-date">
                {{ moment(item.name).format('YYYY-MM-DD') }}
              </div>
            </div>
            <div class="week-day-content">
              <el-tag
                v-for="val in item.value"
                :key="val.Id"
                :type="
                  val.WorkOrderType == '0'
                    ? ''
                    : val.WorkOrderType == '1'
                    ? 'success'
                    : 'warning'
                "
                class="item-tag"
                @click="handleItem(val)"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span> {{ val.WorkOrderTypeName }}</span>
                  <span v-if="val.State === 0">待提交</span>
                  <span type="success" v-if="val.State === 1">已提交</span>
                  <span type="warning" v-if="val.State === 2">进行中</span>
                  <span type="success" v-if="val.State === 3">已完成</span>
                </div>

                <div>{{ val.DeviceItemName }}({{ val.DeviceItemCode }})</div>
                <div>{{ val.InstallationAreaName }}</div>
                <div>{{ val.RealName ? val.RealName : '暂无人员' }}</div>
                <div></div>
              </el-tag>

              <!-- 可在此插入当天的工单等内容 -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
    <ViewForm ref="ViewForm" />
    <PickingForm ref="PickingForm" @success="getDataList" />
    <Log ref="Log" @success="getDataList" />
    <el-dialog title="人员派单" :visible.sync="IsSend" width="30%">
      <div style="text-align: center">
        <div style="display: inline-block">选择人员：</div>
        <SelectData
          v-model="OperatorIds"
          multiple
          url="/Base_Manage/Base_User/GetDataList"
          :option="{
            label: 'RealName',
            Id: 'Id',
          }"
          style="width: 230px; margin-left: 10px"
        ></SelectData>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsSend = false">取 消</el-button>
        <el-button type="primary" @click="handleSendList">确 定</el-button>
      </span>
    </el-dialog>
    <EditFormDisabled ref="EditFormDisabled"></EditFormDisabled>
  </div>
</template>
<script>
import EditForm from './EditForm'
import ViewForm from './ViewForm'
import PickingForm from './PickingForm'
import Log from './Log'
import moment from 'moment'
import { mapState } from 'vuex'
import SelectData from '@/components/SelectData/SelectData.vue'
// 故障详情
import EditFormDisabled from '@/views/Operation/OperationMalfunction/EditForm.vue'

export default {
  data() {
    return {
      moment,
      OperatorIds: [],
      IsSend: false,
      searchData: {
        Code: '',
        State: '',
        WorkOrderDate: [],
        DeviceItemName: '',
        OperatorIds: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      ListType: 1,
      weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      weekDates: [],
      weekType: 'current', // prev/current/next
      weekBase: null, // 当前周的基准日期（周一）
      weekBase2: null, // 当前周的基准日期（周一）
    }
  },
  props: {
    workOrderType: {
      type: String,
      default: '',
    },
  },
  components: {
    EditForm,
    ViewForm,
    Log,
    PickingForm,
    SelectData,
    EditFormDisabled,
  },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'WorkOrderDate', [firstDay, lastDay])
      }
    },
    handleFault(row) {
      let obj = {
        Id: row.FaultId,
      }
      this.$refs.EditFormDisabled.openForm('故障详情', obj, null, false, true)
    },
    handleExamineList(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将批量审查选中的工单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/Device_WorkOrder/WorkOrderReview', {
              ids,
            })
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('审查成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleItem(item) {
      if (item.State !== 0) {
        this.handleView(item)
      } else {
        this.handleAudit(item)
      }
    },
    TypeChange() {
      if (this.ListType === 1) {
        this.handleSearch()
      } else {
        this.getCalendarDataList()
      }
    },
    handleSendList() {
      if (!this.OperatorIds.length) {
        return this.$notify.error('请选择人员')
      }

      let ids = this.selectedRows.map((item) => item.Id)
      this.$confirm(`此操作将派单选中的人员到工单?是否继续？`, {
        type: 'warning',
      }).then((res) => {
        this.IsSend = false
        this.loading = true
        this.$http
          .post('/Base_DeviceTreeManage/Device_WorkOrder/WorkOrderDispatch', {
            Ids: [...ids],
            UserIds: [...this.OperatorIds],
          })
          .then((res) => {
            this.loading = false
            if (res.Success) {
              this.$notify.success('派单成功')

              this.getDataList()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    selectable(row) {
      return row.State == 0
    },
    handleLog(row) {
      this.$refs.Log.openForm('工单审查', row)
    },
    handleApply(row) {
      this.$refs.PickingForm.openForm('工单领料', row)
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_WorkOrder/GetWorkOrderDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'Code',
              Keyword: this.searchData.Code,
            },
            {
              Condition: 'State',
              Keyword: this.searchData.State,
            },
            {
              Condition: 'WorkOrderDate',
              Keyword:
                this.searchData.WorkOrderDate?.length > 0
                  ? this.searchData.WorkOrderDate.join(',')
                  : '',
            },
            {
              Condition: 'DeviceItemName',
              Keyword: this.searchData.DeviceItemName,
            },
            {
              Condition: 'OperatorIds',
              Keyword:
                this.searchData.OperatorIds?.length > 0
                  ? this.searchData.OperatorIds.join(',')
                  : '',
            },
            {
              Condition: 'WorkOrderType',
              Keyword: this.workOrderType || '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    getCalendarDataList() {
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/Device_WorkOrder/GetCalendarWorkOrderDataList',
          {
            SortField: 'CreateTime',
            SortType: 'Desc',
            Search: [
              {
                Condition: 'DeviceType',
                Keyword: this.devTreeSearch.DeviceType || '',
              },
              {
                Condition: 'BuildingId',
                Keyword: this.devTreeSearch.BuildingId || '',
              },
              {
                Condition: 'InstallationArea',
                Keyword: this.devTreeSearch.InstallationArea || '',
              },
              // {
              //   Condition: "Code",
              //   Keyword: this.searchData.Code,
              // },
              {
                Condition: 'State',
                Keyword: this.searchData.State,
              },
              {
                Condition: 'WorkOrderDate',
                Keyword: this.weekBase
                  ? `${moment(this.weekBase).format('YYYY-MM-DD')},${moment(
                      this.weekBase2
                    ).format('YYYY-MM-DD')}`
                  : '',
              },
              {
                Condition: 'DeviceItemName',
                Keyword: this.searchData.DeviceItemName,
              },
              {
                Condition: 'OperatorIds',
                Keyword:
                  this.searchData.OperatorIds?.length > 0
                    ? this.searchData.OperatorIds.join(',')
                    : '',
              },
              {
                Condition: 'WorkOrderType',
                Keyword: this.workOrderType || '',
              },
            ],
          }
        )
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.weekDates = resJson.Data
            // this.tableData = resJson.Data;
            // this.pagination.total = resJson.Total;
            // this.$nextTick(() => {
            //   if (this.$refs.table) {
            //     this.$refs.table.clearSelection();
            //   }
            // });
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建工单')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该工单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/Device_WorkOrder/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleAuditList(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将批量提交通过选中的工单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/Device_WorkOrder/WorkOrderExamine', {
              ids,
            })
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('提交成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑工单', row)
    },
    handleAudit(row) {
      this.$refs.EditForm.openForm('提交工单', row, true)
    },
    handleView(row) {
      this.$refs.ViewForm.openForm('工单详情', row, true)
    },
    setWeekDates(type = this.weekType) {
      // type: prev, current, next
      let base
      if (!this.weekBase) {
        // 初始化为本周一
        const today = moment()
        base = today.clone().startOf('week').add(1, 'day')
      } else {
        base = this.weekBase.clone()
      }
      if (type === 'prev') {
        //上周
        base = base.clone().subtract(7, 'days')
      } else if (type === 'next') {
        //下周
        base = base.clone().add(7, 'days')
      } else if (type === 'current') {
        //本周
        const today = moment()
        base = today.clone().startOf('week').add(1, 'day')
      }
      this.weekBase = base.clone()
      this.weekBase2 = base.clone().add(6, 'day')
      this.weekType = type
      this.getCalendarDataList()
    },
    getWeekDayName(idx) {
      const arr = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      return arr[idx] || ''
    },
  },
  mounted() {},
  created() {
    this.TypeChange()
    // this.setWeekDates();
    // this.getCalendarDataList();
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.TypeChange()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 70px);
}
.rr .div-center {
  margin-top: 10px;
  height: calc(100% - 70px);
  overflow-y: auto;
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
/* 让el-calendar高度100%并自适应父容器 */
.calendar-full-height {
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

::v-deep .el-calendar__body {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
::v-deep .el-calendar-table {
  flex: 1;
  height: 100%;
}
::v-deep .el-calendar-day {
  height: 100%;
}
/* 只影响 el-calendar 的星期头部 */
::v-deep .el-calendar-table th {
  position: relative;
}
::v-deep .el-calendar-table th:nth-child(1)::before {
  content: '周';
}
::v-deep .el-calendar-table th:nth-child(2)::before {
  content: '周';
}
::v-deep .el-calendar-table th:nth-child(3)::before {
  content: '周';
}
::v-deep .el-calendar-table th:nth-child(4)::before {
  content: '周';
}
::v-deep .el-calendar-table th:nth-child(5)::before {
  content: '周';
}
::v-deep .el-calendar-table th:nth-child(6)::before {
  content: '周';
}
::v-deep .el-calendar-table th:nth-child(7)::before {
  content: '周';
}
/* 让el-calendar插槽中的el-tag内容可换行 */
::v-deep .el-calendar .el-tag {
  white-space: normal !important;
  word-break: break-all;
  display: block;
  margin-bottom: 4px;
  line-height: 1.5;
  width: 100%;
  box-sizing: border-box;
}
/* 周日历表美化 */
.week-calendar {
  display: flex;
  width: 100%;

  min-height: 300px;
  border: none;
  background: #f6f8fa;
  justify-content: space-between;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  min-height: 100%;
}
.week-day {
  width: calc(100% / 7.1);
  display: flex;
  flex-direction: column;
  background: #fff;

  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s;
  border: 1px solid #ebeef5;
  position: relative;
  min-height: 100%;
}
.week-day:first-child {
  margin-left: 0;
}
.week-day:last-child {
  margin-right: 0;
}
.week-day:hover {
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.12);
  // border-color: #409eff;
}
.week-day-header {
  background: linear-gradient(90deg, #e3f0ff 0%, #f5f7fa 100%);
  text-align: center;
  padding: 14px 0 10px 0;
  font-weight: bold;
  font-size: 16px;
  color: #409eff;
  border-bottom: 1px solid #ebeef5;
  letter-spacing: 2px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: relative;
}
.week-day-date {
  font-size: 13px;
  color: #909399;
  font-weight: normal;
  margin-top: 2px;
}
.week-day-content {
  flex: 1;
  padding: 16px 10px;
  min-height: 60px;
  background: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  transition: background 0.2s;
}
.week-day-content:hover {
  background: #f4faff;
}
.week-calendar-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;
}
.item-tag {
  width: 100%;
  height: 80px !important;
  cursor: pointer;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  div {
    width: 100%;
  }
}
.link {
  border-bottom: 1px solid #409eff;
  color: #409eff;
  cursor: pointer;
}
</style>
